module.exports = ".mat-form-field {\n    display: block !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/autowithdrawal/addautowithdrawal/addautowithdrawal.component.css
// module id = ./src/app/autowithdrawal/addautowithdrawal/addautowithdrawal.component.css
// module chunks = main